// order-service defaults an order's currency to GBP when none is set
// (services/order-service); the catalog's unitPrice is in the same units,
// so GBP is the honest formatting, not an arbitrary pick. One formatter,
// shared by the product cards and the cart.
const priceFormat = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" });

export function formatMoney(amount: number): string {
  return priceFormat.format(amount);
}
